exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-2f878c97]:before{content:\"\";width:100%;height:100%;z-index:1;position:absolute;top:0;background:linear-gradient(180deg,rgba(0,0,0,.43) 0,rgba(0,0,0,.52) 5%,rgba(0,0,0,.1) 10%,rgba(0,0,0,.64) 46%,rgba(0,0,0,.19))}.current-year[data-v-2f878c97]{font-size:7rem;height:8rem;text-shadow:0 0 15px #000;margin-top:-2rem;margin-left:-.5rem}@media (min-width:768px){.current-year[data-v-2f878c97]{font-size:10rem;height:12rem;text-shadow:0 0 15px #000;margin-top:-4rem}}", ""]);

// exports
